import React from 'react';
import {
  getSubCategoryId,
} from '../utils/DictionaryManagementUtils';
import SimulatorsViewerArrangement
  from '../components/SimulatorsComponents/FullPagesComponents/SimulatorsViewerArrangement';
import SelectSourceFP from '../components/SimulatorsComponents/FullPagesComponents/Services/Source/SelectSourceFP';

const Sim_J03_LoanSelectSource = ({
  globJSON,
  selectedScreen,
  simPlatform,
}) => {
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const { source } = globJSON.configurations.services[subCategoryId];

  return (
    <SimulatorsViewerArrangement>
      <SelectSourceFP
        globJSON={globJSON}
        simPlatform={simPlatform}
        headlineText={source.select_loan_source}
      />
    </SimulatorsViewerArrangement>
  );
};

export default Sim_J03_LoanSelectSource;
